import React from 'react'
import { Link } from 'react-router-dom'

export function Logo({ to = '/', compact = false }) {
  return (
    <Link className="logo" to={to} aria-label="Channel Backup home">
      <span className="logo-mark" aria-hidden="true">
        <svg viewBox="0 0 28 28"><path d="M14 2.5 24 6v7.1c0 6.2-4.1 10.6-10 12.4-5.9-1.8-10-6.2-10-12.4V6l10-3.5Z"/><path d="m9.4 14 3 3 6.3-6.4"/></svg>
      </span>
      {!compact && <span>channel backup</span>}
    </Link>
  )
}

export function Arrow({ size = 16 }) {
  return <svg className="icon" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
}

export function Check() {
  return <span className="check" aria-hidden="true">✓</span>
}

export function Spinner() {
  return <span className="spinner" aria-label="Loading" />
}

export function PrimaryLink({ to, children, className = '' }) {
  return <Link to={to} className={`button button-primary ${className}`}>{children}</Link>
}

export function StatusDot({ status = 'protected' }) {
  return <span className={`status-dot status-${String(status).replace(/\s+/g, '-')}`} />
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-statement">The channel is an account.<br/><em>The work is your life.</em></div>
      <div className="footer-bottom">
        <Logo />
        <div><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><a href="mailto:hello@influencerbackups.com">Contact</a></div>
        <span>© {new Date().getFullYear()}</span>
      </div>
    </footer>
  )
}
